import { useEffect, useState } from "react";
import { FACTS } from "../data/nap";
import api from "../lib/api";
import { Editable } from "./edit/Editable";

// The key facts as ordinary sentences — what an AI answer engine quotes. Same text is baked into the pre-rendered HTML.
export function FactsBlock({ compact = false }) {
  const [priceFact, setPriceFact] = useState("");
  useEffect(() => { api.get("/seo/price-fact").then(({ data }) => setPriceFact(data.text || "")).catch(() => {}); }, []);
  const facts = FACTS.map((f) => (f === "" ? priceFact : f)).filter(Boolean);  // the price sentence comes from the live menu
  return (
    <section className={compact ? "text-sm text-neutral-700 space-y-2" : "text-base text-neutral-800 space-y-3 leading-relaxed"} data-testid="facts-block" aria-label="About Urban Turban by VeerGi">
      <Editable as="h2" k="facts.heading" fallback="About Urban Turban by VeerGi" label="About heading" className="text-base md:text-lg font-extrabold" />
      {facts.map((f, i) => <Editable as="p" key={i} k={`facts.${i + 1}`} fallback={f} label={`Fact ${i + 1}`} multiline testId={`fact-${i + 1}`} />)}
    </section>
  );
}
